
    var riot = require('riot')
    
import vars from '@/vars'
riot.tag2('fb-pages', '<div class="block-facebook" if="{mode == &quot;pc&quot;}"> <p class="title">facebookもチェック！</p> <div class="box"> <div id="fb-root"></div> <div class="fb-page" data-href="https://www.facebook.com/go.biwako" data-width="480" data-hide-cover="false" data-show-facepile="true" data-show-posts="true"> <div class="fb-xfbml-parse-ignore"> <blockquote cite="https://www.facebook.com/go.biwako"><a href="https://www.facebook.com/go.biwako">[go.biwako] Travel Guide of Shiga Prefecture, Japan</a></blockquote> </div> </div> </div> <div class="box"> <div id="fb-root"></div> <div class="fb-page" data-href="https://www.facebook.com/biwaichi.shiga" data-width="480" data-hide-cover="false" data-show-facepile="true" data-show-posts="true"> <div class="fb-xfbml-parse-ignore"> <blockquote cite="https://www.facebook.com/biwaichi.shiga"><a href="https://www.facebook.com/biwaichi.shiga">ビワイチ：しが・びわこめぐりの旅</a></blockquote> </div> </div> </div> </div>', 'fb-pages .fb_iframe_widget { min-height: 500px; background-color: #eee; }', '', function(opts) {
        (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = "//connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v2.3";
        fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = "//connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v2.3";
        fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

    const self = this
    console.log(self)

    self.on('mount', () => {
      vars.uacheck(self)
      self.update()
      if( self.mode == "sp" ) {
        self.unmount()
      } else {
        $(".block-facebook", self.root)
          .addClass("is-active")
      }
    })

});
    
  


// WEBPACK FOOTER //
// ./_src/js/riot/fb-pages.tag